import { render } from "./MaterialsLinks.vue?vue&type=template&id=3778b292&scoped=true"
import script from "./MaterialsLinks.vue?vue&type=script&lang=js"
export * from "./MaterialsLinks.vue?vue&type=script&lang=js"

import "./MaterialsLinks.vue?vue&type=style&index=0&id=3778b292&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3778b292"]])

export default __exports__